import React from "react";
import { useNavigate } from "react-router-dom";
import Div100vh from "react-div-100vh";

import { landlordBenefits } from "@/lib/data";
import bgBhai from "@/assets/images/bubbles.jpg";
import Header from "@/components/common/Header/header";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";

export default function LandlordBenefits() {
  const navigate = useNavigate();

  return (
    <Div100vh
      className="flex flex-col bg-[#010101] bg-no-repeat bg-cover py-4 px-6 items-center justify-between"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(1, 1, 1, 1) 10%, rgba(1, 1, 1, 1) 0% ,rgba(1, 1, 1, 0) 100%), url(${bgBhai})`,
      }}
    >
      <div className="w-full">
        <Header
          customBackSubmit={() => navigate("/landlord")}
          heading="Benefits on joining CirclePe Club"
        />
      </div>
      <div className="flex flex-col gap-4 sm:gap-6 overflow-y-scroll">
        {landlordBenefits.map((benefit, index) => (
          <div
            key={index}
            className="flex flex-col bg-[#444] bg-opacity-30 px-6 p-3 rounded-lg backdrop-blur-2xl border border-[#888]/50"
          >
            <div className="gap-1 flex flex-col">
              <h2 className="text-xs sm:text-md font-medium">
                {benefit.title}
              </h2>
              <p className="text-2xs font-light sm:text-xs text-gray-300">
                {benefit.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <PrimaryButton
        text="Next"
        handleClick={() => navigate("/platform-charges")}
      />
    </Div100vh>
  );
}
